/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import {
  AgenciesApiService,
  Agency,
  ApiService,
  AuthenticatedApiService,
  User,
  UsersApiService,
} from 'rest-client';
import { from, Observable } from 'rxjs';

import { UserStateModel } from '../../states/auth-state/auth.model';

@Injectable()
export class UserService {
  constructor(
    private usersApiService: UsersApiService,
    private agenciesApiService: AgenciesApiService,
    private unauthenticatedApi: ApiService,
    private authenticatedApi: AuthenticatedApiService
  ) { }

  getUser(): Observable<User> {
    return from(this.usersApiService.getUser());
  }

  getAgency(): Observable<Agency> {
    return from(this.agenciesApiService.getAgency());
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  resetPassword(email: string): Observable<any> {
    return from(this.usersApiService.requestNewPassword(email));
  }

  setForcedLang(lang: string): Observable<User> {
    return from(this.usersApiService.setForcedLang(lang));
  }
  setDefaultInvoice(invoiceId: number | string): Observable<User> {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return from(this.usersApiService.setDefaultInvoice(invoiceId));
  }

  setUserAtLocalStorage(user: User): void {
    let authToken = JSON.parse(localStorage.getItem('auth_token'));
    authToken.user = user;
    authToken = JSON.stringify(authToken);
    localStorage.setItem('auth_token', authToken);
  }

  setUtm(userData: UserStateModel, utm: any, email?: string): any {
    const params = {
      email: userData ? userData.email : email,
      id_client: userData ? userData.id : null,
      utm_source: utm.utm_source,
      utm_medium: utm.utm_medium,
      utm_campaign: utm.utm_campaign,
      utm_term: utm.utm_term,
    };

    return params;
  }

  sendUtm(userData?: User, email?: string): void {
    const utm = JSON.parse(localStorage.getItem('utm'));

    if (utm && utm.timestamp_send === null) {
      const params = this.setUtm(userData, utm, email);

      this.authenticatedApi.post(`clientstats/utm`, params).subscribe({
        next: () => {
          utm.timestamp_send = Date.now();
          localStorage.setItem('utm', JSON.stringify(utm));
        },
        error: (error: HttpErrorResponse) => console.error('UTM send error:', error)
      });
    }
  }
}
